module.exports = __webpack_public_path__ + "static/productRegisterImage-1cd72847b997d28d43dc5deac03da188.png";